export default "__VITE_ASSET__4120f96e__"